import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Plus, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

export function LandingFAQ() {
  const { t } = useTranslation();
  const items = t("landing.faq.items", { returnObjects: true });
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      className="border-t border-zinc-200 bg-white py-24"
      data-testid="landing-faq"
    >
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-zinc-950 md:text-4xl">
          {t("landing.faq.title")}
        </h2>
        <div className="mt-10 divide-y divide-zinc-200 border-y border-zinc-200">
          {Array.isArray(items) &&
            items.map((it, i) => {
              const isOpen = i === open;
              return (
                <button
                  key={i}
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`landing-faq-item-${i}`}
                  className="flex w-full items-start gap-4 py-5 text-left transition-colors hover:bg-zinc-50/70"
                >
                  <span
                    className={cn(
                      "mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full transition-colors",
                      isOpen
                        ? "bg-violet-600 text-white"
                        : "bg-zinc-100 text-zinc-500"
                    )}
                  >
                    {isOpen ? (
                      <Minus className="h-3.5 w-3.5" strokeWidth={2.5} />
                    ) : (
                      <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />
                    )}
                  </span>
                  <div className="flex-1">
                    <div className="font-display text-base font-bold text-zinc-950 md:text-lg">
                      {it.q}
                    </div>
                    {isOpen && (
                      <p className="mt-2 text-sm leading-relaxed text-zinc-600 md:text-base">
                        {it.a}
                      </p>
                    )}
                  </div>
                </button>
              );
            })}
        </div>
      </div>
    </section>
  );
}
